import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.labOrderDetails || initialState;

export const selectOrderDetails = createSelector(
  [selectDomain],
  (state) => state.details
);
export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
